import React from 'react';
import { Type, IconArrowRight, ButtonTertiary } from '@spotify-internal/encore-creator-web';
import { spacer8, black } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { CardContainer } from './styles';

type Props = {
  imageUrl: string;
  href: string;
  title: string;
  titleColor?: string;
  description: string;
  callToAction: {
    external: boolean;
    text: string;
  };
  onClick?: () => void;
};

export function Card({
  imageUrl,
  href,
  title,
  titleColor = black,
  description,
  callToAction,
  onClick,
}: Props) {
  const history = useHistory();

  /* istanbul ignore next */
  const handleCardClick = () => {
    callToAction.external ? window.open(href, '_blank') : history.push(href);

    if (onClick) onClick();
  };

  return (
    <CardContainer onClick={handleCardClick}>
      <img src={imageUrl} style={{ width: '100%' }} />
      <TextContainer>
        <Type as="h2" typeColor={titleColor} variant={Type.heading3}>
          {title}
        </Type>
        <Type as="p" variant={Type.body1}>
          {description}
        </Type>
        <Type as="p" variant={Type.cta3}>
          <CallToActionButton>
            {callToAction.text} <CallToActionButtonArrow />
          </CallToActionButton>
        </Type>
      </TextContainer>
    </CardContainer>
  );
}

const TextContainer = styled.div`
  padding: 26px;
`;

export const CallToActionButton = styled(ButtonTertiary).attrs({
  buttonSize: 'sm',
  condensed: true,
})`
  display: flex;
  align-items: center;
  transform: none;

  /* https://ghe.spotify.net/creator/encore-creator-web/blob/master/src/styles/mixins/buttons.js#L94-L104 */
  &::after {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    cursor: pointer;
    content: '';
  }
`;

export const CallToActionButtonArrow = styled(IconArrowRight).attrs({
  iconSize: 16,
})`
  margin-left: ${spacer8};
`;
